import { render, staticRenderFns } from "./courseShareTestDialog.vue?vue&type=template&id=34460ed4&scoped=true&"
import script from "./courseShareTestDialog.vue?vue&type=script&lang=js&"
export * from "./courseShareTestDialog.vue?vue&type=script&lang=js&"
import style0 from "./courseShareTestDialog.vue?vue&type=style&index=0&id=34460ed4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34460ed4",
  null
  
)

export default component.exports